import { ArrowRight } from '@remarkable/ark-icons';
import { Tag, Typography } from '@remarkable/ark-web';
import type { ReactNode } from 'react';
import React, { useMemo } from 'react';
import { Button } from 'src/components';
import { valueProps } from 'src/utils/valueProps';

interface LandingFooterProps {
  heading: string;
  buttonText: string;
  componentLocation: string;
  linkTo: string;
}

export const LandingFooter: React.FC<LandingFooterProps> = ({
  heading,
  buttonText,
  componentLocation,
  linkTo,
}) => {
  const valuePropsData = useMemo(() => {
    return Object.values(valueProps.connectDetailed);
  }, []);

  return (
    <div
      data-cy="connect-offer-perks"
      className="px:24 lm:px-100 max-w-full bg-neutral-dark-6 px-24 pb-24 text-white"
    >
      <div className="m-auto flex max-w-l2xl flex-col gap-40 py-64 lm:gap-[63px] lm:py-80">
        <Typography variant="heading-md" id="learn">
          {heading}
        </Typography>

        <ul className="grid w-full grid-cols-1 justify-between gap-32 ls:grid-cols-2 lm:gap-40 ll:grid-cols-4">
          {valuePropsData.map((vp) => (
            <li key={vp.id} className="flex flex-col gap-16">
              <div className="flex size-56 shrink-0 items-center justify-center rounded-full bg-neutral-dark-3">
                <vp.icon size={32} className="shrink-0" />
              </div>

              <Typography variant="heading-subtle-md">
                {vp.title}
                {'badge' in vp && (
                  <Tag
                    size="medium"
                    variant="themed-filled"
                    className="ml-8 inline align-middle"
                  >
                    {vp.badge as ReactNode}
                  </Tag>
                )}
              </Typography>
              <Typography variant="body-sm">{vp.description}</Typography>
            </li>
          ))}
        </ul>

        <Button
          as="a"
          to={linkTo}
          variant="primary"
          className="m-auto w-full ls:w-fit"
          analytics={{
            action: 'Activate connect',
            location: componentLocation,
            text: buttonText,
          }}
        >
          <span>{buttonText}</span> <ArrowRight />
        </Button>
      </div>
    </div>
  );
};
